import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import DialogContent from '@mui/material/DialogContent';
import { useCallback } from 'react';
import { thunkSetLastNewsItemHash } from '../../redux/actions/selfDataActions';
import { useAppDispatch } from '../../redux/store';
import { NewsContents } from '../../scenes/entry/news/newsContents';
import { getNewsItemHash, getNewsItems } from '../../scenes/entry/news/newsItems';
import { OpenModalContainer } from '../openModalContainer';
export const NewsModalContainer = ({ onClose, lastNewsItemHash }) => {
    const dispatch = useAppDispatch();
    const onCloseNewsModal = useCallback(() => {
        const newsItems = getNewsItems();
        const latestNewsItem = newsItems.length ? newsItems[newsItems.length - 1] : undefined;
        if (latestNewsItem) {
            const newLastNewsItemHash = getNewsItemHash(latestNewsItem);
            dispatch(thunkSetLastNewsItemHash(newLastNewsItemHash));
        }
        onClose();
    }, [dispatch, onClose]);
    return (_jsx(OpenModalContainer, { title: 'News', onClose: onCloseNewsModal, maxWidth: 'md', children: _jsx(DialogContent, { children: _jsx(NewsContents, { numItemsPerPage: 10, lastNewsItemHash: lastNewsItemHash }) }) }));
};
